import React from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { Switch, Route } from 'react-router'
import DashboardContainer from '../pages/Dashboard'
import LoginContainer from 'pages/Auth/Login'
import RegisterContainer from '../pages/Auth/Register'
import LogoutContainer from '../pages/Auth/Logout'
import ResetPassword from '../pages/Auth/ResetPassword'
import UsersContainer from '../pages/User'
import InvitesContainer from 'pages/Invites'
// import SecurityContainer from 'pages/security'
// import GroupsContainer from 'pages/Groups'
import SettingsContainer from 'pages/settings'
import { AppRouteURI } from './RoleBasedAccess'
import NotFound from '../components/app/NotFound'
import RouteAuth from './RouteAuth'
import GuestRoute from './GuestRoute'
import { VerifyEmail } from 'pages/Auth/VerifyEmail/VerifyEmail'
// import OktaLogin from 'pages/Auth/OktaLogin'
import TwoFactorAuth from 'pages/Auth/TwoFactorAuth'
import AnalyticsContainer from 'pages/Analytics'
// import PermissionsContainer from 'pages/Permissions'

const AppRouter = ({ history }) => {
    return (
        <ConnectedRouter history={history}>
            <Switch>
                <RouteAuth
                    exact
                    path={AppRouteURI.HOME}
                    component={DashboardContainer}
                />
                <GuestRoute path={AppRouteURI.LOGIN} component={LoginContainer} />
                {/* <Route path={AppRouteURI.OKTALOGIN} component={OktaLogin} /> */}
                <Route path={AppRouteURI.LOGOUT} component={LogoutContainer} />
                <GuestRoute
                    path={AppRouteURI.REGISTER}
                    component={RegisterContainer}
                />
                <Route
                    path={AppRouteURI.INVITATION}
                    component={RegisterContainer}
                />
                <RouteAuth
                    path={AppRouteURI.MEMBERS}
                    component={UsersContainer}
                />
                {/* <RouteAuth
                    path={AppRouteURI.SECURITY}
                    component={SecurityContainer}
                /> */}
                <RouteAuth
                    path={AppRouteURI.SETTINGS}
                    component={SettingsContainer}
                />
                {/* <RouteAuth
                    path={AppRouteURI.GROUPS}
                    component={GroupsContainer}
                />
                <RouteAuth
                    path={AppRouteURI.PERMISSIONS}
                    component={PermissionsContainer}
                /> */}
                <RouteAuth
                    path={AppRouteURI.INVITES}
                    component={InvitesContainer}
                />
                <RouteAuth
                    path={AppRouteURI.ANALYTICS}
                    component={AnalyticsContainer}
                />
                <Route path={AppRouteURI.RESET_PWD} component={ResetPassword} />
                <Route
                    path={AppRouteURI.TWO_FACTOR}
                    component={TwoFactorAuth}
                />
                <Route
                    path={AppRouteURI.VERIFY_EMAIL}
                    component={VerifyEmail}
                />
                <Route component={NotFound} />
            </Switch>
        </ConnectedRouter>
    )
}

export default AppRouter
